function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function (callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function (cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function (variant_id, quantity, index, callback) {
    getCartUpdate(index, quantity, callback)
}

Shopify.removeItem = function (variant_id, index, callback) {
    getCartUpdate(index, 0, callback)
}

function getCartUpdate(line, quantity, callback) {
    const body = JSON.stringify({
        line,
        quantity,
        sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);

            if (parsedState.errors) {
                showWarning('Error : ' + parsedState.errors, warningTime);
                return;
            }

            if ((typeof callback) === 'function') {
                callback(parsedState);
            } else {
                Shopify.onCartUpdate(parsedState);
            }
        })
        .catch((e) => {
            console.error(e);
        })
}

Shopify.addItem = function (variant_id, quantity, $target, callback, input = null) {
    var quantity = quantity || 1;
    // $.param encodes each pair: properties used to be concatenated raw, so a value with &, +, = or % split
    // into extra fields, lost its plus signs, or broke the request.
    const fields = [{ name: 'quantity', value: quantity }, { name: 'id', value: variant_id }];

    $target.closest('form').find('[name^="properties"]').each((index, element) => {
        fields.push({ name: $(element).attr('name'), value: $(element).val() });
    });

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: $.param(fields),
        dataType: 'json',
        success: function (line_item) {
            trackAddToCart($target);
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            // input is optional (null from callers that pass none): reading .length on it threw here, so the
            // button kept spinning and no error was shown. Without a stock number, keep the shopper's quantity.
            var message = window.cartStrings.addProductOutQuantity2,
                maxValue = input && input.length > 0 ? parseInt(input.attr('data-inventory-quantity')) : NaN;

            // Only an over-stock refusal lowers the shopper's quantity; a sold-out or network error left it at
            // the stock number too.
            if (!isNaN(maxValue) && maxValue > 0 && quantity > maxValue) {
                message = getInputMessage(maxValue)
                input.val(maxValue)
            }

            $target.removeClass('is-loading');
            Shopify.onError(XMLHttpRequest, textStatus, message);
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function (line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function (XMLHttpRequest, textStatus, message) {
    // JSON.parse, not eval: a non-JSON body (network drop, HTML error page) threw and hid the warning.
    var data = {};
    try { data = JSON.parse(XMLHttpRequest.responseText) || {}; } catch (e) { }
    if (!!data.message) {
        !!data.description ? showWarning(data.description) : showWarning(data.message + ': ' + message, warningTime);
    } else {
        showWarning('Error : ' + message, warningTime);
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeCart = false;
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const $target = event.target
        let el_input = $target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = $target.closest('.product-form')?.querySelector('[data-btn-addtocart]');
        let newVal, checkAvailabel = false;

        const policyArray = document.body.matches('.quickshop-popup-show') ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`],
            currentId = document.body.matches('.quickshop-popup-show') ? this.closest('.productView-options').querySelector('[name="id"]').value : this.input.dataset.cartQuantityId,
            thisVariantStatus = policyArray[currentId];

        buttonAdd?.dataset.available == 'false' || buttonAdd?.dataset.available == undefined ? checkAvailabel = true : checkAvailabel = false;

        if ($target.matches('.plus')) newVal = value + 1;
        else if ($target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal < 0) newVal = 1;

        if (newVal > inStockNumber && checkAvailabel && thisVariantStatus == 'deny') {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }

        el_input.value = newVal;

        if (typeof this.changeCart == 'number') { clearTimeout(this.changeCart) };
        this.changeCart = setTimeout(() => { if ($target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent) }, 350);
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray == undefined ? false : sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue'
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }

    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

        if (newVal > inStockNumber && !buttonAdd.matches('.button--pre-untrack')) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }

        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

class ProductScroller extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('[data-drag-container]');
        this.dragParent = this.querySelector('[data-drag-parent]');

        this.initDragToScroll();
        this.initScrollEnhancements();
    }

    disconnectedCallback() {
        if (this.onPageScroll) window.removeEventListener('scroll', this.onPageScroll);
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.contentObserver) this.contentObserver.disconnect();
        clearTimeout(this._resumeT);
        clearInterval(this.autoplayTimer);
        if (this._animRAF) cancelAnimationFrame(this._animRAF);
        if (this._autoRAF) cancelAnimationFrame(this._autoRAF);
        if (this._contentRAF) cancelAnimationFrame(this._contentRAF);
    }

    /*
     * Opt-in enhancements for the scroll layout: desktop prev/next arrows and/or
     * page-scroll-coupled infinite drift. Each is gated by a data attribute the
     * section emits only when its setting is on, so default scroll blocks are
     * untouched, and everything is wired by JS so no-JS visitors keep a plain,
     * manually-scrollable row.
     *
     * Reuse over reinvention:
     *  - arrow buttons + look: the merchant's `window.arrows` markup + `.slick-arrow`
     *    styling (same blur + hover-accent as the Slick slider layout).
     *  - per-click distance: a page of visible items, mirroring Slick slidesToScroll.
     *  - boundary disable: scrollLeft vs scrollWidth — the same idea Slick uses.
     *
     * The scrollable element is `.products-flex` (overflow:auto) = dragParent.
     */
    initScrollEnhancements() {
        // scrollLeft semantics invert under RTL across browsers; keep this LTR-only
        // rather than ship a subtly-broken loop/boundary. (Store is LTR.)
        if (document.body.classList.contains('layout_rtl')) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoOn = this.hasAttribute('data-auto-scroll') && !reduceMotion;
        this.arrowsOn = this.hasAttribute('data-arrows');
        // Slider-parity features (opt-in, emitted by the section only when its
        // matching setting is on): dots, timed autoplay, item counter, and an
        // explicit infinite ring for arrow/dot/autoplay nav (the scroll layout's
        // ring is normally gated behind auto-drift; `data-loop` decouples it).
        this.dotsDesktop = this.hasAttribute('data-dots');
        this.dotsMobile = this.hasAttribute('data-dots-mb');
        this.dotsOn = this.dotsDesktop || this.dotsMobile;
        this.autoplayOn = this.hasAttribute('data-autoplay') && !reduceMotion;
        this.counterOn = this.hasAttribute('data-counter');
        this.loopWanted = this.hasAttribute('data-loop');
        if (!this.autoOn && !this.arrowsOn && !this.dotsOn && !this.autoplayOn && !this.counterOn) return;

        const scroller = this.dragParent;
        if (!scroller || scroller.children.length < 2) return;
        this.scroller = scroller;
        this.smoothBehavior = reduceMotion ? 'auto' : 'smooth';

        this.advance = 0;            // one item's width incl. gap (auto/loop only)
        this.loopable = false;       // enough content to recycle seamlessly
        this.userInteracting = false;
        this.pointerActive = false;
        this.ticking = false;
        this.perPage = 1;
        this._dotPages = -1;
        this._pages = -1;

        if (this.autoOn) this.setupAutoScroll(scroller);
        if (this.arrowsOn) this.setupArrows();
        if (this.dotsOn) this.buildDots();
        if (this.counterOn) this.counterEl = this.querySelector('.products-counter-number #count-image');
        this.progressThumb = this.querySelector('.slider-progress-bar .scrollbar-thumb');
        // A finite slider with no auto-drift still needs the interaction guards so
        // autoplay backs off while the visitor is dragging/touching the row.
        if (this.autoplayOn && !this.autoOn) this.bindInteractionGuards();
        if (this.autoplayOn) this.setupAutoplay();

        // One scroll + resize pipeline feeds the loop ring, arrows, dots, counter
        // and progress bar.
        scroller.addEventListener('scroll', () => this.onScrollerScroll(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.onResize());
        this.resizeObserver.observe(scroller);
        // Dots/counter must re-sync after the server-rendered loading skeletons are
        // AJAX-swapped for the final cards. Pure auto-drift/arrows rows don't need
        // this and keep their original observer-free behaviour (no measure() churn
        // from loop reorders mid-drift).
        if (this.dotsOn || this.counterOn) {
            this.contentObserver = new MutationObserver(() => this.onContentChanged());
            this.contentObserver.observe(scroller, { childList: true });
        }

        this.measure();
        this.rebuildDots();
        this.updateArrows();
        this.updateCounter();
        this._pages = this.pageCount();
    }

    setupAutoScroll(scroller) {
        this.direction = this.getAttribute('data-auto-direction') === 'right' ? 1 : -1;
        const speed = parseFloat(this.getAttribute('data-auto-speed')) || 4;
        this.factor = speed * 0.15; // horizontal px per vertical-scroll px
        this.inView = false;
        this.lastPageY = window.scrollY;
        this.pendingAutoDelta = 0;

        scroller.classList.add('products-flex--auto');
        scroller.style.overscrollBehaviorX = 'none';
        this.bindInteractionGuards();

        // Drift only while the row is fully on screen (or fills the screen). Drifting from the first visible
        // pixel moved the row about a card before the shopper could see it, so it never arrived with the
        // first product at the left edge.
        this.viewObserver = new IntersectionObserver((entries) => {
            const e = entries[0];
            const full = Math.min(e.boundingClientRect.height, window.innerHeight) * 0.9;
            const inView = e.isIntersecting && e.intersectionRect.height >= full;
            if (inView && !this.inView) this.lastPageY = window.scrollY; // avoid a jump on entry
            this.inView = inView;
        }, { threshold: [0, 0.25, 0.5, 0.75, 0.9, 1] });
        this.viewObserver.observe(this);

        this.onPageScroll = () => this.handlePageScroll();
        window.addEventListener('scroll', this.onPageScroll, { passive: true });
    }

    setupArrows() {
        const host = this.container || this; // .halo-block-content — gets position:relative via CSS
        host.classList.add('has-scroll-arrows');
        this.prevArrow = this.buildArrow('prev');
        this.nextArrow = this.buildArrow('next');
        this.prevArrow.addEventListener('click', (e) => { e.preventDefault(); this.pageScroll(-1); });
        this.nextArrow.addEventListener('click', (e) => { e.preventDefault(); this.pageScroll(1); });
        host.append(this.prevArrow, this.nextArrow);
    }

    // Reuse the merchant's chosen arrow button; add `.slick-arrow` so the shared
    // Slick arrow styling applies (window.arrows markup ships only slick-prev/next).
    buildArrow(dir) {
        const markup = dir === 'prev'
            ? (window.arrows && window.arrows.icon_prev)
            : (window.arrows && window.arrows.icon_next);
        const holder = document.createElement('div');
        holder.innerHTML = markup || `<button type="button" class="slick-${dir}" aria-label="${dir}"></button>`;
        const btn = holder.firstElementChild;
        btn.classList.add('slick-arrow', 'scroll-arrow', `scroll-arrow--${dir}`);
        return btn;
    }

    // Per click: a page of visible items, mirroring the slider's slidesToScroll.
    pageScroll(sign) {
        const arrow = sign < 0 ? this.prevArrow : this.nextArrow;
        if (arrow && arrow.classList.contains('disabled')) return;
        const pitch = this.itemPitch();
        if (!pitch) return;
        const perPage = this.fullCardsInView(pitch);
        const step = sign * perPage * pitch;

        if (this.loopable) {
            // Infinite recycle: animate ourselves and recycle every frame so going
            // left reveals the wrapped items seamlessly (relative delta).
            this.animateScroll(step);
            return;
        }
        // Finite. `data-loop` (no continuous driver) wraps at the ends so it still
        // feels infinite while keeping scrollLeft readable for the dots.
        const s = this.scroller;
        const max = s.scrollWidth - s.clientWidth;
        let target = s.scrollLeft + step;
        if (this.loopWanted) {
            if (sign > 0 && s.scrollLeft >= max - 2) target = 0;        // wrap to start
            else if (sign < 0 && s.scrollLeft <= 2) target = max;       // wrap to end
        }
        target = Math.min(Math.max(0, target), max);
        this.animateScroll(target - s.scrollLeft);
    }

    // Eased scrollLeft tween that keeps the loop ring seamless on every frame.
    animateScroll(total) {
        if (this._animRAF) cancelAnimationFrame(this._animRAF);

        // CSS scroll-snap (mandatory) hijacks programmatic scrolling — a native
        // smooth scrollTo resolves to a snap point, frequently 0. So we drive
        // scrollLeft by hand here and suppress snap for the duration, restoring it
        // afterwards so manual swipes still snap crisply.
        this.scroller.style.scrollSnapType = 'none';

        // Reduced motion: jump instantly (still seamless via recycle).
        if (this.smoothBehavior === 'auto') {
            this.scroller.scrollLeft += total;
            this.maintainLoop();
            this.scroller.style.scrollSnapType = '';
            return;
        }

        this.userInteracting = true; // pause page-scroll drift while the tween runs
        const duration = 450;
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
        let elapsed = 0, lastTs = null, applied = 0;

        const step = (ts) => {
            if (lastTs === null) lastTs = ts;
            elapsed += ts - lastTs;
            lastTs = ts;
            const target = total * easeOutCubic(Math.min(1, elapsed / duration));
            this.scroller.scrollLeft += target - applied; // recycling jumps aren't counted in `applied`
            applied = target;
            this.maintainLoop();                          // keep the ring seamless mid-tween
            if (elapsed < duration) {
                this._animRAF = requestAnimationFrame(step);
            } else {
                this._animRAF = null;
                this.scroller.style.scrollSnapType = ''; // restore CSS snap
                clearTimeout(this._resumeT);
                this._resumeT = setTimeout(() => { this.userInteracting = false; }, 150);
            }
        };
        this._animRAF = requestAnimationFrame(step);
    }

    // The row's cards. A banner slide (data-pb-slide, sections/product-block.liquid) leads the row and is wider
    // than a card, so it is left out of every per-card measurement.
    items() {
        return [...this.scroller.children].filter((el) => !el.hasAttribute('data-pb-slide'));
    }

    hasSlide() {
        return !!(this.scroller && this.scroller.querySelector(':scope > [data-pb-slide]'));
    }

    // Whole cards that fit the visible width. round(width / pitch) counted a half-card peek as a card (5.5 -> 6)
    // and, without a peek, missed the last gap (5 cards = 5 widths + 4 gaps, under 5 pitches).
    fullCardsInView(pitch) {
        const gap = pitch - this.items()[0].getBoundingClientRect().width;
        return Math.max(1, Math.floor((this.scroller.clientWidth + gap) / pitch + 0.02));
    }

    // Distance between adjacent items (item width + gap), measured live.
    itemPitch() {
        const items = this.items();
        if (items.length < 2) return 0;
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    }

    // Item pitch + whether there's room to recycle without exposing a gap. Loop-only.
    measure() {
        if (!this.autoOn && !this.autoplayOn && !this.loopWanted) return;
        this.advance = Math.round(this.itemPitch());
        // The DOM-recycle ring keeps scrollLeft pinned in a runway band, which is
        // perfect for continuous motion (auto-drift / autoplay) but breaks discrete
        // dot/arrow paging (the page can't be read back from scrollLeft). So the
        // ring is reserved for the auto-drift feature (which never has dots); every
        // native slider — including autoplay — pages finitely, with `data-loop`
        // wrapping at the ends for the infinite feel (see pageScroll / updateArrows).
        // The ring assumes every child is one pitch wide; a banner slide is not, so a row with one drifts
        // finitely instead.
        const recycle = this.autoOn && !this.hasSlide();
        // Need >= 3 item-pitches of slack: one buffer each side plus a band wider
        // than one item, otherwise the two recycle loops can fight each other.
        this.loopable = recycle && this.advance > 0 &&
            this.scroller.scrollWidth >= this.scroller.clientWidth + this.advance * 3;
        // Left-hand runway: maintainLoop moves the last item in front and shifts scrollLeft by the same
        // amount, so the first product stays at the left edge. (Setting scrollLeft = advance directly
        // scrolled the first product off screen.)
        this.maintainLoop();
    }

    // Recycle edge items to the opposite end so scrollLeft never reaches a hard
    // edge. Same DOM nodes are reordered (a ring) — no clones, so every card stays
    // interactive and there are no duplicate element IDs.
    maintainLoop() {
        // Moving the focused card would drop keyboard focus.
        if (!this.loopable || this.userInteracting || this.scroller.contains(document.activeElement)) return;
        const s = this.scroller;
        const max = s.scrollWidth - s.clientWidth;
        const current = Math.min(Math.max(s.scrollLeft, 0), max);
        if (current > max - this.advance) {
            s.appendChild(s.firstElementChild);
            s.scrollLeft = current - this.advance;
        } else if (current < this.advance) {
            s.insertBefore(s.lastElementChild, s.firstElementChild);
            s.scrollLeft = current + this.advance;
        }
    }

    // prev disabled at the left edge, next at the right edge — finite mode only.
    // An infinite (loopable) ring never reaches an edge, so arrows stay active.
    updateArrows() {
        if (!this.arrowsOn || !this.prevArrow) return;
        const s = this.scroller;
        // Nothing to scroll (fewer cards than fit): no arrows, even with wrap-around on.
        const scrollable = s.scrollWidth > s.clientWidth + 1;
        this.prevArrow.style.display = this.nextArrow.style.display = scrollable ? '' : 'none';
        // A recycle ring never reaches an edge; a wrap-around (data-loop) slider
        // does, but its arrows loop past it — keep both active either way.
        const wraps = this.loopable || this.loopWanted;
        this.setArrowDisabled(this.prevArrow, !wraps && s.scrollLeft <= 1);
        this.setArrowDisabled(this.nextArrow, !wraps && s.scrollLeft >= s.scrollWidth - s.clientWidth - 1);
    }

    setArrowDisabled(arrow, disabled) {
        arrow.classList.toggle('disabled', disabled);
        arrow.setAttribute('aria-disabled', disabled);
    }

    onScrollerScroll() {
        if (this.userInteracting && !this.pointerActive) this.scheduleInteractionResume();
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            this.maintainLoop();
            this.updateArrows();
            this.updateDots();
            this.updateCounter();
            this.updateProgress();
            this.ticking = false;
        });
    }

    /* ---- Pagination dots (reuse the merchant's .slick-dots styling) ---- */
    buildDots() {
        const ul = document.createElement('ul');
        ul.className = 'slick-dots pb-dots';
        // Per-breakpoint visibility mirrors the slider's desktop/mobile dot toggles;
        // CSS hides the off side so one DOM serves both.
        if (!this.dotsDesktop) ul.classList.add('pb-dots--d-off');
        if (!this.dotsMobile) ul.classList.add('pb-dots--m-off');
        this.dotsEl = ul;
        this.appendChild(ul);
    }

    pageCount() {
        const pitch = this.itemPitch();
        if (!pitch || !this.scroller) return 0;
        this.perPage = this.fullCardsInView(pitch);
        if (this.hasSlide()) {
            // Children are not all one pitch wide: count pages from the scroll distance.
            const max = this.scroller.scrollWidth - this.scroller.clientWidth;
            return max <= 1 ? 1 : 1 + Math.ceil(max / (this.perPage * pitch) - 0.05);
        }
        return Math.max(1, Math.ceil(this.scroller.children.length / this.perPage));
    }

    currentPage() {
        const pitch = this.itemPitch();
        if (!pitch) return 0;
        // At the end of the row the last dot is current, even when the final page is a partial one.
        const s = this.scroller;
        if (this.dotsEl && this.dotsEl.children.length && s.scrollLeft >= s.scrollWidth - s.clientWidth - 2) {
            return this.dotsEl.children.length - 1;
        }
        return Math.round(this.scroller.scrollLeft / (this.perPage * pitch));
    }

    // Rebuild the dot list only when the page count changes (AJAX swap, resize) —
    // a loop reorder keeps the count, so it just re-highlights.
    rebuildDots() {
        if (!this.dotsEl) return;
        const pages = this.pageCount();
        if (pages === this._dotPages) { this.updateDots(); return; }
        this._dotPages = pages;
        this.dotsEl.textContent = '';
        // A single page needs no dots (matches Slick hiding them).
        if (pages <= 1) return;
        for (let i = 0; i < pages; i++) {
            const li = document.createElement('li');
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = i + 1;
            b.setAttribute('aria-label', `${i + 1} / ${pages}`);
            b.addEventListener('click', () => this.goToPage(i));
            li.appendChild(b);
            this.dotsEl.appendChild(li);
        }
        this.updateDots();
    }

    updateDots() {
        if (!this.dotsEl) return;
        const cur = Math.min(this.currentPage(), this.dotsEl.children.length - 1);
        const lis = this.dotsEl.children;
        for (let i = 0; i < lis.length; i++) {
            lis[i].classList.toggle('slick-active', i === cur);
            if (i === cur) lis[i].firstElementChild.setAttribute('aria-current', 'true');
            else lis[i].firstElementChild.removeAttribute('aria-current');
        }
    }

    goToPage(i) {
        const pitch = this.itemPitch();
        if (!pitch) return;
        const max = this.scroller.scrollWidth - this.scroller.clientWidth;
        // Last dot snaps to the true end so the final card isn't left clipped by
        // perPage rounding (a half-visible card fits fewer than a whole page).
        let target = (i >= this._dotPages - 1) ? max : i * this.perPage * pitch;
        target = Math.min(Math.max(0, target), max);
        this.animateScroll(target - this.scroller.scrollLeft);
    }

    /* ---- Item counter (e.g. "8 / 12") ---- */
    updateCounter() {
        if (!this.counterEl) return;
        const total = this.items().length;
        const shown = Math.min((this.currentPage() + 1) * this.perPage, total);
        this.counterEl.textContent = shown;
    }

    /* ---- Progress bar thumb (reuse the slider's --percent contract) ---- */
    updateProgress() {
        if (!this.progressThumb) return;
        const s = this.scroller;
        const max = s.scrollWidth - s.clientWidth;
        const pct = max > 0 ? (s.scrollLeft / max) * 100 : 0;
        this.progressThumb.style.setProperty('--percent', pct + '%');
    }

    /* ---- Timed autoplay (distinct from page-scroll drift) ---- */
    setupAutoplay() {
        this.autoplayMs = parseInt(this.getAttribute('data-autoplay-speed'), 10) || 4000;
        this.autoplayPaused = false;
        this.addEventListener('pointerenter', () => { this.autoplayPaused = true; });
        this.addEventListener('pointerleave', () => { this.autoplayPaused = false; });
        this.autoplayTimer = setInterval(() => this.autoplayTick(), this.autoplayMs);
    }

    autoplayTick() {
        if (this.autoplayPaused || this.userInteracting || document.hidden || !this.scroller) return;
        const s = this.scroller;
        // Finite at the end: glide back to the start; otherwise advance a page
        // (pageScroll wraps on its own when data-loop is set).
        if (!this.loopable && !this.loopWanted && s.scrollLeft >= s.scrollWidth - s.clientWidth - 2) {
            this.animateScroll(-s.scrollLeft);
        } else {
            this.pageScroll(1);
        }
    }

    // Viewport/card resize: item pitch may have changed, so always re-measure the
    // loop runway (original auto-scroll behaviour), then refresh the slider chrome.
    onResize() {
        this.measure();
        this.rebuildDots();
        this.updateArrows();
        this.updateCounter();
        this.updateProgress();
    }

    // childList changed (AJAX skeleton→card swap). rAF-debounced and gated on the
    // page count so a loop reorder — which also mutates childList — never triggers
    // measure()'s scrollLeft re-seed and fights an in-flight drift/tween.
    onContentChanged() {
        if (this._contentRAF) cancelAnimationFrame(this._contentRAF);
        this._contentRAF = requestAnimationFrame(() => {
            this._contentRAF = null;
            const pages = this.pageCount();
            if (pages !== this._pages) {
                this._pages = pages;
                this.measure();
                this.rebuildDots();
            }
            this.updateArrows();
            this.updateDots();
            this.updateCounter();
            this.updateProgress();
        });
    }

    // Page scroll -> horizontal drift. Scrolling up makes deltaY negative, which
    // reverses the drift for free. maintainLoop runs via the scroller's own event.
    handlePageScroll() {
        const y = window.scrollY;
        const deltaY = y - this.lastPageY;
        this.lastPageY = y;
        if (!this.inView || this.userInteracting || deltaY === 0) return;
        this.pendingAutoDelta += deltaY * this.factor * this.direction;
        if (this._autoRAF) return;
        this._autoRAF = requestAnimationFrame(() => {
            this._autoRAF = null;
            if (this.userInteracting) {
                this.pendingAutoDelta = 0;
                return;
            }
            const limit = this.advance || this.scroller.clientWidth;
            const delta = Math.min(Math.max(this.pendingAutoDelta, -limit), limit);
            this.pendingAutoDelta = 0;
            this.scroller.scrollLeft += delta;
            this.maintainLoop();
        });
    }

    // Don't fight an active drag/touch on the row. (Vertical wheel/scrollbar page
    // scrolling must still drift, so wheel is intentionally not a pause trigger.)
    bindInteractionGuards() {
        const pause = () => {
            clearTimeout(this._resumeT);
            this.pointerActive = true;
            this.userInteracting = true;
        };
        const resume = () => {
            this.pointerActive = false;
            this.scheduleInteractionResume();
        };
        this.scroller.addEventListener('pointerdown', pause, { passive: true });
        ['pointerup', 'pointercancel', 'mouseleave'].forEach((ev) =>
            this.scroller.addEventListener(ev, resume, { passive: true }));
    }

    scheduleInteractionResume() {
        clearTimeout(this._resumeT);
        this._resumeT = setTimeout(() => {
            if (this.pointerActive) return;
            this.userInteracting = false;
            this.maintainLoop();
        }, 200);
    }

    initDragToScroll() {
        const isOverflowing = (wrapper) => {
            return wrapper.clientWidth < wrapper.scrollWidth
        }
        let containerOverflowing = isOverflowing(this.container)

        if (containerOverflowing) {
            this.dragToScroll(this.container)
            return
        }
        this.dragToScroll(this.dragParent)
    }

    // Mouse drag. Snap is off while dragging (mandatory snap pulled every scrollLeft write back to the nearest card),
    // and comes back on release, which settles the row on a card. A drag starts after 5px, so a slightly shaky
    // click still opens the card; the browser's own image/link drag is cancelled.
    dragToScroll(slider) {
        let mouseDown = false;
        let dragging = false;
        let start;
        let scrollLeft;
        let inactiveTimeout;

        const end = () => {
            if (!mouseDown) return;
            mouseDown = false;
            slider.style.scrollSnapType = '';
            if (!dragging) return;
            dragging = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        };

        slider.addEventListener('dragstart', (e) => e.preventDefault());

        slider.addEventListener('mousedown', (e) => {
            if (e.button !== 0) return;
            mouseDown = true;
            start = e.pageX;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseup', end);
        slider.addEventListener('mouseleave', end);

        slider.addEventListener('mousemove', (e) => {
            if (!mouseDown) return;
            const walk = e.pageX - start;
            if (!dragging) {
                if (Math.abs(walk) < 5) return;
                dragging = true;
                slider.style.scrollSnapType = 'none';
                slider.classList.add('active');
            }
            e.preventDefault();
            slider.scrollLeft = scrollLeft - walk;
        });
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super()

        this.imageContainer = this;
        this.initObserver();
    }

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        },
            {
                threshold: 0.4
            });

        this.observer.observe(this.imageContainer);
    }
}

// global.js is deferred, so the rows are parsed by now: wire them before load (dots and arrows used to appear only
// after every image had loaded, and pushed the rows below down).
customElements.define('product-scroller', ProductScroller);

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    // customElements.define('image-to-flip', ImageToFlip);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

// One Clarity event per successful add, named by where it came from (atc-pdp, atc-sticky, atc-quickshop,
// atc-quickview, atc-card). The click-time cta-atc-pdp (halo-toolcart.js) stays for the existing readouts.
function trackAddToCart($target) {
    if (typeof window.clarity !== 'function' || !$target || !$target.length) return;

    const button = $target[0];
    let source = 'card';
    if (button.closest('[data-quick-view-popup]')) {
        source = 'quickview';
    } else if (button.id === 'product-add-to-cart') {
        source = button.dataset.atcVia || 'pdp';
        delete button.dataset.atcVia;
    } else if (button.closest('[id^="product-form-sticky-"]')) {
        source = 'sticky';
    } else if (button.closest('.quickshop-popup-show, #halo-card-mobile-popup, #list-view-popup, [data-quickshop-popup-option-3]')) {
        source = 'quickshop';
    }

    try { window.clarity('event', 'atc-' + source); } catch (e) {}
}

// The sticky bar's 45px thumbnail after a variant change: the variant image at 135px, not the original file.
function stickyThumb(src) {
    return src ? `${src}${src.includes('?') ? '&' : '?'}width=135` : src;
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options);
        this.observer.observe(this);
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
    this.loadScrolling();
})

window.onscroll = () => { this.loadScrolling() };

function loadScrolling() {
    document.querySelectorAll('[data-scrolling]').forEach(element => { element.dataset.scrolling == 'vertical' ? this.scrollVertical(element) : this.scrollHorizontal(element) })
}

function scrollVertical(element) {
    const $thisItem = element.closest('.special-banner__item') || element,
        top = $thisItem.getBoundingClientRect().top,
        height = $thisItem.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        coefficient = element.scrollHeight / height,
        redundant = height >= wdHeight ? 0 : (wdHeight - height) / 2;

    if (top - redundant < 0 && top > height * -1) this.scrollTop(element, (top * -1 + redundant) * coefficient)
    else if (top - redundant >= 0) this.scrollTop(element, 0)
    else this.scrollTop(element, element.scrollHeight)
}

function scrollTop(element, scope) {
    element.scrollTo({ top: scope, behavior: "smooth" })
}

function scrollHorizontal(element) {
    const $thisFirst = element.querySelector('.scrolling-text__list--1'),
        $thisSecond = element.querySelector('.scrolling-text__list--2');

    if (!$thisFirst) return;

    const top = element.getBoundingClientRect().top,
        height = element.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        scrollWidth = $thisFirst.scrollWidth > window.innerWidth ? $thisFirst.scrollWidth - window.innerWidth : 0,
        contentHeight = $thisFirst.getBoundingClientRect().height * 2,
        redundant = height >= wdHeight ? 0 : (wdHeight - height) / 2,
        coefficient = scrollWidth / (height / 2 + redundant - contentHeight);

    let scope = (top * -1 + redundant) * coefficient,
        scope2 = (height / 2 - contentHeight + redundant) * coefficient - scope;

    if (top - redundant < 0 && top - contentHeight > height * -1 / 2) { scope = scope * -1; scope2 = scope2 * -1 }
    else if (top - redundant >= 0) { scope = 0; scope2 = scrollWidth * -1 }
    else { scope = scrollWidth * -1; scope2 = 0 }
    $thisFirst.scrollWidth <= window.innerWidth ? $thisSecond.style.justifyContent = 'flex-end' : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
    $thisFirst.style.transform = `translateX(${scope}px)`;
    $thisSecond.style.transform = `translateX(${(scope2)}px)`;
}

class SmoothScrollMenu {
    constructor(selector) {
        this.menuItems = document.querySelectorAll(selector);
        this.attachEvents();
        this.hideMenuItemsWithoutSection();
    }

    attachEvents() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== "#") {
                anchor.addEventListener('click', event => this.handleMenuItemClick(event, anchor));
            }
        });
    }

    handleMenuItemClick(event, anchor) {
        event.preventDefault();

        var targetHref = anchor.getAttribute('href');
        var shouldScroll = true;
        const location = window.location.pathname + window.location.hash;

        if (targetHref.includes('/') && location !== targetHref) {
            window.location.href = targetHref;
            shouldScroll = false;
        }

        if (shouldScroll) {
            var targetElement = document.getElementById(anchor.getAttribute('href').split('#')[1]);
            if (targetElement) {
                this.scrollToSection(targetElement);
            }
        }
    }

    scrollToSection(element) {
        this.smoothScrollTo(element);
    }

    smoothScrollTo(element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop
        });
    }

    hideMenuItemsWithoutSection() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            const hash = anchor.getAttribute('href').split('#')[1];
            if (hash !== undefined && hash !== '' && !document.getElementById(hash)) {
                item.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new SmoothScrollMenu('.header__inline-menu .menu-lv-1');
    customElements.define('details-disclosure', DetailsDisclosure);
});

class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp);
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.focus();
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open')
    }
}

class AccountIcon extends HTMLElement {
    constructor() {
        super();

        this.icon = this.querySelector('.icon');
    }

    connectedCallback() {
        document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
    }

    handleStorefrontSignInCompleted(event) {
        if (event?.detail?.avatar) {
            this.icon?.replaceWith(event.detail.avatar.cloneNode());
        }
    }
}

customElements.define('account-icon', AccountIcon);

class PositiveVibesComponent extends HTMLElement {
    constructor() {
        super();
        this.productPositiveVibes();
    }

    productPositiveVibes() {
        const parent = this.querySelector('.text-vibes');
        const children = this.querySelectorAll('.text-vibes--child');
        let currentIndex = 0;

        if (children.length > 1) {
            const newDiv = document.createElement("div");
            newDiv.classList.add("text-vibes--child");
            newDiv.innerHTML = children[0].innerHTML;
            parent.appendChild(newDiv);

            const childrens = parent.querySelectorAll('.text-vibes--child');
            setInterval(() => {
                const height = childrens[currentIndex].offsetHeight;
                childrens.forEach((child, index) => {
                    parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
                    if (currentIndex == 0) {
                        parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
                    }
                });
                currentIndex = (currentIndex + 1) % childrens.length;
                this.heightPositive();
            }, 3000);
        }
    }

    heightPositive() {
        const parent = this.querySelector('.text-vibes');
        const childrens = this.querySelectorAll('.text-vibes--child');

        let maxHeight = 0;
        childrens.forEach(child => {
            maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
        });

        this.style.minHeight = maxHeight + 'px';

        childrens.forEach(child => {
            child.style.minHeight = `${maxHeight}px`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    customElements.define('positive-vibes', PositiveVibesComponent);
})

function checkTransparentHeader() {
    allowTransparent();

    if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", allowTransparent);
        document.addEventListener("shopify:section:unload", allowTransparent);
        document.addEventListener("shopify:section:reorder", allowTransparent);
    }
}

function allowTransparent() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
        return;
    } else {
        document.querySelector("body").removeAttribute("allow-transparency");
    }
}

document.addEventListener('DOMContentLoaded', function () {
    checkTransparentHeader();
});

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = false;
        this.ids = [];
    }

    startQueue(id, quantity) {
        this.queue.push({ id, quantity });
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue);
                }
            } else {
                clearInterval(interval);
            }
        }, 250);
    }

    sendRequest(queue) {
        this.requestStarted = true;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity;
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items);
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;

        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue);
        }
    }

    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            return `${window.location.pathname}`;
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
}

class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');

        if (this.input) {
            this.input.form.addEventListener('reset', this.onFormReset.bind(this));
            this.input.addEventListener('input', debounce((event) => {
                this.onChange(event);
            }, 200).bind(this))
        }
    }

    shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a')
    }

    onFormReset(event) {
        // Prevent default so the form reset doesn't set the value gotten from the url on page load
        event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
            this.input.value = '';
            this.input.focus();
        }
    }
}
customElements.define('search-form', SearchForm);
